module.exports = __webpack_public_path__ + "img/18.03953b4e.jpg";